export default __webpack_public_path__ + "static/media/icon-negociacao.321a55ca.svg";